// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationEmailTemplateLogoDto
 */
export interface IOrganizationEmailTemplateLogoDto {
    /**
     * 
     * @type {string}
     * @memberof IOrganizationEmailTemplateLogoDto
     */
    logo_url?: string;
}

/**
 * Check if a given object implements the IOrganizationEmailTemplateLogoDto interface.
 */
export function instanceOfIOrganizationEmailTemplateLogoDto(value: object): value is IOrganizationEmailTemplateLogoDto {
    return true;
}

export function IOrganizationEmailTemplateLogoDtoFromJSON(json: any): IOrganizationEmailTemplateLogoDto {
    return IOrganizationEmailTemplateLogoDtoFromJSONTyped(json, false);
}

export function IOrganizationEmailTemplateLogoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationEmailTemplateLogoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'logo_url': json['logo_url'] == null ? undefined : json['logo_url'],
    };
}

export function IOrganizationEmailTemplateLogoDtoToJSON(json: any): IOrganizationEmailTemplateLogoDto {
    return IOrganizationEmailTemplateLogoDtoToJSONTyped(json, false);
}

export function IOrganizationEmailTemplateLogoDtoToJSONTyped(value?: IOrganizationEmailTemplateLogoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logo_url': value['logo_url'],
    };
}

